import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../environments/environment';

// Service
import { GlobalService } from '../../shared/service/global.service';

@Component({
  selector: 'app-card-article',
  templateUrl: './card-article.component.html'
})
export class CardArticleComponent implements OnInit {
  
  @Input() type;
  @Input() dataArticle;
  @Input() height = '200px';
  apiAsset = environment.API_ASSETS;

  constructor( public globalService : GlobalService ) { }

  ngOnInit(): void {

  }

}
